import { render, staticRenderFns } from "./SignBatch.vue?vue&type=template&id=19f05890"
import script from "./SignBatch.vue?vue&type=script&lang=js"
export * from "./SignBatch.vue?vue&type=script&lang=js"
import style0 from "./SignBatch.vue?vue&type=style&index=0&id=19f05890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports